import React from 'react';
import { string, object, oneOfType, bool } from 'prop-types';
import cx from 'classnames';
import withId from './../../utils/withId';

import TooltipStatic from './Tooltip.static';

const CLASS_ROOT = 'tooltip';

class Tooltip extends React.Component {
  static displayName = 'Tooltip';

  static propTypes = {
    /** Tooltip dialog content */
    dialog: oneOfType([string, object]),
    /** Class names applied to dialog */
    dialogClassName: string,
    /** Tooltip ID */
    id: string,
    /** Use a div to wrap the tooltip trigger. Default is span. */
    isBlockElement: bool,
  };

  componentDidMount() {
    this.tooltip = new TooltipStatic(this.dialogRef);
  }

  componentWillUnmount() {
    this.tooltip.destroy();
  }

  getTrigger() {
    const { children, className, id, dialog, ...other } = this.props;
    if (React.Children.count(children) === 1) {
      if (typeof children === 'string') {
        return this.wrapTrigger(children);
      }
      return React.cloneElement(children, {
        tabIndex: 0,
        'aria-describedby': id,
        'aria-owns': id, // helps NVDA speak the description text
        ...other,
      });
    }
    return this.wrapTrigger(children);
  }

  wrapTrigger = content => {
    const { className, id, dialog, isBlockElement, ...other } = this.props;
    const Tag = isBlockElement ? 'div' : 'span';

    return (
      <Tag
        key="tooltipTrigger"
        tabIndex="0" // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
        className={className}
        aria-describedby={id}
        aria-owns={id} // helps NVDA speak the description text
        {...other}
      >
        {content}
      </Tag>
    );
  };

  render() {
    const { dialog, dialogClassName, id } = this.props;
    const dialogClasses = cx(CLASS_ROOT, dialogClassName);

    return (
      <React.Fragment>
        {this.getTrigger()}
        <span
          key="tooltipDialog"
          id={id}
          className={dialogClasses}
          role="tooltip"
          aria-hidden="true"
          ref={ref => {
            this.dialogRef = ref;
          }}
          data-tooltip
        >
          <span className="tooltip__inner">
            <span className="tooltip__arrow" />
            <span className="tooltip__content">{dialog}</span>
          </span>
        </span>
      </React.Fragment>
    );
  }
}

export default withId(Tooltip);



// WEBPACK FOOTER //
// ./src/components/Tooltip/Tooltip.js